import { createUseStyles } from 'react-jss';
const buttonHeight = 36;
export const useLivechatButtonStyles = createUseStyles({
    'livechat-button': ({ theme, visible }) => ({
        outline: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        height: buttonHeight,
        padding: '0px 8px 0px 12px',
        color: 'white',
        position: 'fixed',
        bottom: '16%',
        left: visible ? 0 : -buttonHeight,
        marginBottom: '62px',
        borderWidth: '1px 1px 0px 1px',
        borderColor: 'white',
        borderStyle: 'solid',
        borderRadius: '4px 4px 0px 0px',
        transform: 'rotate(90deg) translate(-100%, -50%)',
        transformOrigin: 'left center',
        transition: 'left 0.17s ease-in 0s',
        zIndex: 990000,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        boxShadow: theme.shadows.dropdown,
        fontFamily: theme.typography.fontFamily,
        ...theme.typography.variants['body-medium-semi-bold'],
        background: theme.gradients['primary-hovered'],
        '&:hover': {
            background: theme.gradients.primary,
        },
        '&:focus-visible': {
            boxShadow: `0 0 0 1px ${theme.colors.white}, 0 0 0 3px ${theme.colors.sea}`,
        },
    }),
    'livechat-button-icon': {
        transform: 'rotate(-90deg)',
        marginLeft: '6px',
    },
});
